module.exports = __webpack_public_path__ + "media/images/front/pc/collaboration/my_atopy_line/q-bg-8b30ba802506a9f7c28d9ae67d549731.svg";